import {
  SET_THIRD_PARTY_ACCOUNTS,
  SET_METRC_ACCOUNT,
  SET_METRC_FACILITIES,
  SET_METRC_LOCATION_TYPES,
  SET_LINX_ACCOUNTS,
  SET_QUICKBOOK_CONFIG,
  SET_QUICKBOOK_OPERATIONS,
  SET_QUICKBOOK_CATEGORIES,
  SET_QUICKBOOK_ACCOUNT_DETAILS,
  RESET,
  SET_MTRAC_ACCOUNTS,
  SET_CLOVER_ACCOUNTS,
  SET_THIRD_PARTY_PRODUCTS,
  SET_THIRD_PARTY_BRANDS,
  SET_LEAFLY_ACCOUNTS,
  SET_LEAFLY_ACCOUNT,
  SET_BIOTRACK_ACCOUNT,
  SET_UTAH_ICS_ACCOUNT,
  SET_NM_CCD_ACCOUNT,
  SET_WA_CCRS_ACCOUNT,
} from '../types/thirdParty'
import {
  getThirdPartyAccountsAPI,
  deleteThirdPartyAccountAPI,
  addThirdPartyAccountAPI,
  updateThirdPartyAccountAPI,
  getMetrcAPI,
  getMetrcFacilitiesAPI,
  updateMetrcAccountAPI,
  updateLinxAccountAPI,
  getQuickBookConfigurationsAPI,
  getQuickBookAccountDetailsAPI,
  downloadQuickBookFileAPI,
  resetAPI,
  getQuickBookTokenAPI,
  saveEntitiesAPI,
  saveAccountEntitiesAPI,
  disconnectQuickbookAPI,
  quickbookSyncEntitiesAPI,
  getQuickbookEntityAPI,
  getLinxAccountsAPI,
  getMetrcFacilitiesDataAPI,
  getMetrcFacilitiesDataSearchAPI,
  addMetrcAccountAPI,
  getQuickBookOperationsAPI,
  updateQuickBookOperationsAPI,
  getQuickBookLogsAPI,
  getQuickBookSyncErrorLogs,
  reSyncQuickBookOperationsAPI,
  getProductCataogiesAPI,
  thirdPartyProductsAPI,
  thirdPartyBrandsAPI,
  getMenuApiProductsAPI,
  getMenuApiBrandsAPI,
  categoryMappingVersion2API,
  getProductSearchAPI,
  getAllQuickBookAccountDetailsAPI,
  deleteAccountEntitiesAPI,
  updateAccountEntitiesAPI,
  updateBulkUpdatesAPI,
  createLeaflyAccountAPI,
  updateLeaflyAccountAPI,
  getLeaflyAccountAPI,
  getLeaflyAccountByShopAPI,
  getLeaflyAccountsAPI,
  deleteLeaflyAccountAPI,
  syncLeaflyAccountAPI,
  getConnectToQuickBooksURL,
  getQuickBookRefreshTokenAPI,
  getQuickBookRevokeTokenAPI,
  quickBookOnlineDataSyncAPI,
  getQuickBookJobsAPI,
  getQuickBookOnlineTokenInfoAPI,
  getMetrcEmployeeKeysAPI,
  addMetrcEmployeeKeyAPI,
  updateMetrcEmployeeKeyAPI,
  deleteMetrcEmployeeKeyAPI,
  getMetrcLocationTypesAPI,
  createMetrcLocationAPI,
  getPackageTrackingLocationAPI,
  updateDefaultMetrcLocationAPI,
  getBiotrackAccountApi,
  updateBiotrackAccountApi,
  getUtahIcsAccountApi,
  updateUtahIcsAccountApi,
  deleteUtahIcsAccountApi,
  getNmCcdAccountApi,
  updateNmCcdAccountApi,
  deleteNmCcdAccountApi,
  testNmCcdConnectionApi,
  previewNmCcdBatchMappingsApi,
  autoMapNmCcdBatchesApi,
  checkActiveComplianceSyncJobApi,
  getWaCcrsAccountApi,
  updateWaCcrsAccountApi,
  deleteWaCcrsAccountApi,
  testWaCcrsConnectionApi,
} from '../api/thirdParty'
import { syncAPI } from '../api/compliance'
import { addMessageCurry, commonActionAPIHit, commonActionAPIHitWithError } from '../utils/api'
import _ from 'lodash'
import { getMerchantCredentials, getOAuthStatus, updateMerchant } from '../api/complianceService'
import { normalizeNmCcdAccounts, serializeNmCcdRequest } from '../utils/nmCcdCompliance'
import { normalizeWaCcrsAccounts, serializeWaCcrsRequest } from '../utils/waCcrsCompliance'
import { serializeBiotrackConfigRequest } from '../utils/complianceServiceDataBuilders'
import {
  NM_CCD_SYNC_MODEL_TYPE,
  SYNC_NOT_STARTED_MESSAGE,
  SYNC_POLL_INTERVAL_MS,
  SYNC_POLL_TIMEOUT_MS,
  SYNC_TIMEOUT_MESSAGE,
  disableBiotrackLocation,
  findBiotrackLocation,
  isComplianceSyncJobActive,
  migrationErrorMessage,
  normalizeMappingPreview,
} from '../utils/nmCcdMigration'

export const setThirdPartyAccounts = (payload) => ({
  type: SET_THIRD_PARTY_ACCOUNTS,
  payload: payload,
})

//BIOTRACK ACTIONS DEF START
export const setBiotrackAccount = (payload) => ({
  type: SET_BIOTRACK_ACCOUNT,
  payload: payload,
})
//BIOTRACK ACTIONS DEF FINISH

// UTAH ICS ACTIONS DEF START
export const setUtahIcsAccount = (payload) => ({
  type: SET_UTAH_ICS_ACCOUNT,
  payload,
})
export const setNmCcdAccounts = (payload) => ({
  type: SET_NM_CCD_ACCOUNT,
  payload,
})
export const setWaCcrsAccounts = (payload) => ({
  type: SET_WA_CCRS_ACCOUNT,
  payload,
})
// UTAH ICS ACTIONS DEF FINISH

export const setMetrcAccount = (payload) => ({
  type: SET_METRC_ACCOUNT,
  payload,
})

export const setMetrcFacilities = (payload) => ({
  type: SET_METRC_FACILITIES,
  payload,
})

export const setMetrcLocationTypes = (payload) => ({
  type: SET_METRC_LOCATION_TYPES,
  payload,
})

export const setLinxAccount = (payload) => ({
  type: SET_LINX_ACCOUNTS,
  payload,
})

export const setMTracAccount = (payload) => ({
  type: SET_MTRAC_ACCOUNTS,
  payload,
})

export const setQuickBookConfig = (payload) => ({
  type: SET_QUICKBOOK_CONFIG,
  payload,
})
export const setQuickBookAccountDetails = (payload) => ({
  type: SET_QUICKBOOK_ACCOUNT_DETAILS,
  payload,
})
export const setQuickBookOperations = (payload) => ({
  type: SET_QUICKBOOK_OPERATIONS,
  payload,
})
export const setProductCataogies = (payload) => ({
  type: SET_QUICKBOOK_CATEGORIES,
  payload,
})
export const setReset = (payload) => ({
  type: RESET,
  payload,
})

export const setCloverAccount = (payload) => ({
  type: SET_CLOVER_ACCOUNTS,
  payload,
})

export const setThirdPartyProducts = (payload) => ({
  type: SET_THIRD_PARTY_PRODUCTS,
  payload,
})

export const setThirdPartyBrands = (payload) => ({
  type: SET_THIRD_PARTY_BRANDS,
  payload,
})

export const setLeaflyAccounts = (payload) => ({
  type: SET_LEAFLY_ACCOUNTS,
  payload,
})

export const setLeaflyAccount = (payload) => ({
  type: SET_LEAFLY_ACCOUNT,
  payload,
})

export const getThirdPartyAccounts = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getThirdPartyAccountsAPI(), dispatch)
        .then((thirdPartyAccounts) => {
          resolve(thirdPartyAccounts)
          dispatch(setThirdPartyAccounts({ thirdPartyAccounts }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const deleteThirdPartyAccount = commonActionAPIHit(deleteThirdPartyAccountAPI)
export const addNewThirdPartyAccount = commonActionAPIHit(addThirdPartyAccountAPI)
export const updateThirdPartyAccount = commonActionAPIHit(updateThirdPartyAccountAPI)

//BIOTRACK START

export const getBiotrackAccount = () => {
  return (dispatch) => {
    return new Promise((resolve, _) => {
      addMessageCurry(getBiotrackAccountApi(), dispatch)
        .then(async (biotrackAccountList) => {
          const updatedList = await Promise.all(
            biotrackAccountList.map(async (account) => {
              const locations = account?.locations || []
              const locationsWithDates = await loadExpirationDates(locations)

              return {
                ...account,
                locations: locationsWithDates,
              }
            }),
          )

          resolve(updatedList)
          dispatch(setBiotrackAccount({ biotrackAccount: updatedList }))
        })
        .catch((err) => console.log(err, 'getBiotrackAccount'))
    })
  }
}

export const getUtahIcsAccount = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getUtahIcsAccountApi(), dispatch)
        .then((utahIcsAccountResponse) => {
          const utahIcsAccount = normalizeUtahIcsResponse(utahIcsAccountResponse)
          resolve(utahIcsAccount)
          dispatch(setUtahIcsAccount({ utahIcsAccount }))
        })
        .catch((err) => console.log(err, 'getUtahIcsAccount'))
    })
  }
}

export const getNmCcdAccounts = () => (dispatch) =>
  getNmCcdAccountApi().then((response) => {
    const nmCcdAccounts = normalizeNmCcdAccounts(response)
    dispatch(setNmCcdAccounts({ nmCcdAccounts }))
    return nmCcdAccounts
  })

export const getWaCcrsAccounts = () => (dispatch) =>
  getWaCcrsAccountApi().then((response) => {
    const waCcrsAccounts = normalizeWaCcrsAccounts(response)
    dispatch(setWaCcrsAccounts({ waCcrsAccounts }))
    return waCcrsAccounts
  })

const loadExpirationDates = async (locations) => {
  return Promise.all(
    locations.map(async (location) => {
      let isBiotrackOAuthConfigured = false
      let expirationDate = null

      try {
        const response = await getMerchantCredentials(location.companyId, location.shopId)
        const biotrackAccount = response?.data?.attributes?.complianceConfigs?.find(
          ({ complianceType }) => complianceType === 'BIOTRACK',
        )

        isBiotrackOAuthConfigured = Boolean(
          biotrackAccount?.oauthClientId && biotrackAccount?.oauthClientSecret,
        )

        if (isBiotrackOAuthConfigured) {
          const res = await getOAuthStatus(location.companyId, location.shopId)
          expirationDate = res?.data?.expiresAt || null
        }
      } catch (error) {}

      return {
        ...location,
        isBiotrackOAuthConfigured,
        expirationDate,
      }
    }),
  )
}

const normalizeUtahIcsResponse = (accountsResponse) => {
  const facilities = Array.isArray(accountsResponse)
    ? accountsResponse.map((account) => ({
        ...account,
        id: account.id || account._id,
      }))
    : []
  const baseAccount = facilities[0] || {}
  return {
    complianceType: baseAccount.complianceType || 'UTAH_ICS',
    stateCode: baseAccount.stateCode,
    environment: baseAccount.environment,
    clientId: baseAccount.clientId,
    clientSecret: baseAccount.clientSecret,
    sourceSystem: baseAccount.sourceSystem,
    facilities,
  }
}

const normalizeUtahIcsRequest = (account = {}, facility = {}) => {
  return {
    id: facility.id || facility._id,
    complianceType: account.complianceType || 'UTAH_ICS',
    shopId: facility.shopId,
    stateCode: facility.stateCode || account.stateCode,
    environment: facility.environment || account.environment,
    facilityCode: facility.facilityCode || account.facilityCode,
    clientId: facility.clientId || account.clientId,
    clientSecret: facility.clientSecret || account.clientSecret,
    sourceSystem:
      facility.sourceSystem ||
      facility.facilityCode ||
      account.sourceSystem ||
      account.facilityCode,
    enabled: !!facility.enabled,
    enableSync: !!facility.enableSync,
  }
}

//BIOTRACK FINISH

// metrc

export const getMetrc = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getMetrcAPI(), dispatch)
        .then((metrcAccount) => {
          resolve(metrcAccount)
          dispatch(setMetrcAccount({ metrcAccount }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getMetrcFacilities = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(
        getMetrcFacilitiesAPI(),
        dispatch,
        'Tried to retrieve facilities. Please check your metrc API key',
      )
        .then((metrcFacilities) => {
          resolve(metrcFacilities)
          dispatch(setMetrcFacilities({ metrcFacilities }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getMetrcLocationTypes = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(
        getMetrcLocationTypesAPI(),
        dispatch,
        'Tried to retrieve location types. Please check your metrc API key',
      )
        .then((metrcLocationTypes) => {
          resolve(metrcLocationTypes)
          dispatch(setMetrcLocationTypes({ metrcLocationTypes }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const createMetrcLocation = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(createMetrcLocationAPI(data), dispatch)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getPackageLocationFlag = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getPackageTrackingLocationAPI(), dispatch)
        .then((res) => {
          resolve(res)
          return res
        })
        .catch((err) => console.log(err))
    })
  }
}

export const updateDefaultMetrcLocation = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateDefaultMetrcLocationAPI(data), dispatch)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getMetrcFacilitiesData = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getMetrcFacilitiesDataAPI(), dispatch)
        .then((metrcFacilities) => {
          resolve(metrcFacilities)
          dispatch(setMetrcFacilities({ metrcFacilities }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getMetrcFacilitiesDataSearch = (env, stateCode, apiKey) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getMetrcFacilitiesDataSearchAPI(env, stateCode, apiKey), dispatch)
        .then((metrcFacilities) => {
          resolve(metrcFacilities)
          console.log(metrcFacilities, 'facilities')
          dispatch(setMetrcFacilities({ metrcFacilities }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getLinxAccounts = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getLinxAccountsAPI(), dispatch)
        .then((linxAccounts) => {
          resolve(linxAccounts)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const updateLinxAccountInfo = (linxAccount) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateLinxAccountAPI(linxAccount), dispatch)
        .then((linxAccount) => {
          resolve(linxAccount)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getQuickBookConfigurations = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getQuickBookConfigurationsAPI(), dispatch)
        .then((quickbook) => {
          resolve(quickbook)
          dispatch(setQuickBookConfig({ quickbook }))
        })
        .catch((err) => console.log(err))
    })
  }
}
export const getQuickBookAccountDetails = (referenceId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getQuickBookAccountDetailsAPI(referenceId), dispatch)
        .then((quickbook) => {
          resolve(quickbook)
          dispatch(setQuickBookAccountDetails({ quickbook }))
        })
        .catch((err) => console.log(err))
    })
  }
}
export const getQuickBookLogs = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getQuickBookLogsAPI(data), dispatch)
        .then((quickBookLoogs) => {
          resolve(quickBookLoogs)
          dispatch(setQuickBookConfig({ quickBookLoogs }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getQuickBookOnlineTokenInfo = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getQuickBookOnlineTokenInfoAPI(), dispatch)
        .then((quickbook) => {
          resolve(quickbook)
          dispatch(setQuickBookAccountDetails({ quickbook }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getQuickBookSyncJobs = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getQuickBookJobsAPI(data), dispatch)
        .then((quickBookJobs) => {
          resolve(quickBookJobs)
          dispatch(setQuickBookConfig({ quickBookJobs }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getQuickBookOperations = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getQuickBookOperationsAPI(), dispatch)
        .then((quickbookOpt) => {
          resolve(quickbookOpt)
          dispatch(setQuickBookOperations({ quickbookOpt }))
        })
        .catch((err) => console.log(err))
    })
  }
}
export const getProductCataogies = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getProductCataogiesAPI(), dispatch)
        .then((quickbookCat) => {
          resolve(quickbookCat)
          dispatch(setProductCataogies({ quickbookCat }))
        })
        .catch((err) => console.log(err))
    })
  }
}
export const reset = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(resetAPI(), dispatch)
        .then((reset) => {
          resolve(reset)
          dispatch(setReset({ reset }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const addMetrcAccount = commonActionAPIHit(addMetrcAccountAPI)
export const updateMetrcAccount = commonActionAPIHit(updateMetrcAccountAPI)
export const updateQuickBookOperations = commonActionAPIHit(updateQuickBookOperationsAPI)
export const reSyncQuickBookOperations = commonActionAPIHit(reSyncQuickBookOperationsAPI)
export const downloadQuickBookFile = commonActionAPIHit(downloadQuickBookFileAPI)
export const resets = commonActionAPIHit(resetAPI)
export const getQuickBookToken = commonActionAPIHit(getQuickBookTokenAPI)
export const getQuickBookRefreshToken = commonActionAPIHit(getQuickBookRefreshTokenAPI)
export const getQuickBookRevokeToken = commonActionAPIHit(getQuickBookRevokeTokenAPI)
export const quickBookOnlineDataSync = commonActionAPIHit(quickBookOnlineDataSyncAPI)
export const urlConnectToQuickBooks = commonActionAPIHit(getConnectToQuickBooksURL)
export const saveEntities = commonActionAPIHit(saveEntitiesAPI)
export const saveAccountEntities = commonActionAPIHit(saveAccountEntitiesAPI)
export const updateAccountEntities = commonActionAPIHit(updateAccountEntitiesAPI)
export const updateBulkUpdate = commonActionAPIHit(updateBulkUpdatesAPI)
export const deleteAccountEntities = commonActionAPIHit(deleteAccountEntitiesAPI)
export const disconnectQuickbook = commonActionAPIHit(disconnectQuickbookAPI)
export const quickbookSyncEntities = commonActionAPIHit(quickbookSyncEntitiesAPI)
export const getQuickbookEntity = commonActionAPIHit(getQuickbookEntityAPI)
export const getQuickBookSyncErrors = commonActionAPIHit(getQuickBookSyncErrorLogs)
export const getProductCataogiesAPIs = commonActionAPIHit(getProductCataogiesAPI)
export const getProductSearch = commonActionAPIHit(getProductSearchAPI)
export const getAllQuickBookAccountDetails = commonActionAPIHit(getAllQuickBookAccountDetailsAPI)
export const getMetrcEmployeeKeys = commonActionAPIHit(getMetrcEmployeeKeysAPI)
export const addMetrcEmployeeKey = commonActionAPIHit(addMetrcEmployeeKeyAPI)
export const updateBiotrackAccount = commonActionAPIHit(updateBiotrackAccountApi)
export const updateMetrcEmployeeKey = commonActionAPIHit(updateMetrcEmployeeKeyAPI)
export const deleteMetrcEmployeeKey = commonActionAPIHit(deleteMetrcEmployeeKeyAPI)

export const updateUtahIcsAccount = (account) => {
  return (dispatch) => {
    const facilities = account?.facilities || []
    const requests = facilities.map((facility) => normalizeUtahIcsRequest(account, facility))
    const promises = requests.map((payload) =>
      addMessageCurry(updateUtahIcsAccountApi(payload), dispatch),
    )
    return Promise.all(promises)
  }
}

export const deleteUtahIcsAccount = commonActionAPIHit(deleteUtahIcsAccountApi)

export const updateNmCcdAccount = (account, jwtTokenInput, operation) => (dispatch) => {
  const payload = serializeNmCcdRequest(account, jwtTokenInput, operation)
  return updateNmCcdAccountApi(payload).then((response) => {
    const savedAccount = normalizeNmCcdAccounts(response).find(
      (updatedAccount) =>
        updatedAccount.id === account.id || updatedAccount.shopId === account.shopId,
    )
    return dispatch(getNmCcdAccounts()).then((refreshedAccounts) => {
      const refreshedAccount = refreshedAccounts.find(
        (updatedAccount) => updatedAccount.shopId === account.shopId,
      )
      return refreshedAccount || savedAccount || account
    })
  })
}

export const deleteNmCcdAccount = (accountId) => (dispatch) =>
  deleteNmCcdAccountApi(accountId).then((response) => {
    return dispatch(getNmCcdAccounts()).then(() => response)
  })

export const testNmCcdConnection = (account, jwtTokenInput) => {
  const operation = (jwtTokenInput || '').trim() ? 'replace' : 'preserve'
  const payload = serializeNmCcdRequest(account, jwtTokenInput, operation)
  delete payload.id
  delete payload.companyId
  delete payload.stateCode
  delete payload.enabled
  delete payload.enableSync
  delete payload.enableDelivery
  if (!account.nmCcdOrganizationId) delete payload.nmCcdOrganizationId
  if (!account.nmCcdLocationId) delete payload.nmCcdLocationId
  return () => testNmCcdConnectionApi(payload)
}

export const updateWaCcrsAccount = (account, credentials) => (dispatch) => {
  const payload = serializeWaCcrsRequest(account, credentials)
  return updateWaCcrsAccountApi(payload).then((response) => {
    const savedAccount = normalizeWaCcrsAccounts(response).find(
      (updatedAccount) =>
        updatedAccount.id === account.id || updatedAccount.shopId === account.shopId,
    )
    return dispatch(getWaCcrsAccounts()).then((refreshedAccounts) => {
      return (
        refreshedAccounts.find((updatedAccount) => updatedAccount.shopId === account.shopId) ||
        savedAccount ||
        account
      )
    })
  })
}

export const deleteWaCcrsAccount = (accountId) => (dispatch) =>
  deleteWaCcrsAccountApi(accountId).then((response) =>
    dispatch(getWaCcrsAccounts()).then(() => response),
  )

export const testWaCcrsConnection = (account, credentials) => {
  const payload = serializeWaCcrsRequest(account, credentials)
  delete payload.id
  delete payload.companyId
  delete payload.stateCode
  delete payload.enabled
  delete payload.enableSync
  delete payload.enableDelivery
  return () => testWaCcrsConnectionApi(payload)
}

// Migration wizard thunks call the API directly (no addMessageCurry): the wizard renders its
// own progress and must never raise the global loading overlay.
const defaultWait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

// Queue the package sync for the (now enabled) NM CCD account and wait until the shop has no
// active package sync job. A sync already in progress is attached to rather than failed.
export const syncNmCcdPackages =
  ({
    intervalMs = SYNC_POLL_INTERVAL_MS,
    timeoutMs = SYNC_POLL_TIMEOUT_MS,
    wait = defaultWait,
    now = Date.now,
  } = {}) =>
  () => {
    const deadline = now() + timeoutMs
    const check = () => checkActiveComplianceSyncJobApi(NM_CCD_SYNC_MODEL_TYPE)
    const poll = () =>
      check().then((job) => {
        if (!isComplianceSyncJobActive(job)) return { completedAt: now() }
        if (now() >= deadline)
          return Promise.reject({ code: 'TIMEOUT', message: SYNC_TIMEOUT_MESSAGE })
        return wait(intervalMs).then(poll)
      })
    return syncAPI([NM_CCD_SYNC_MODEL_TYPE])
      .then(() => true)
      .catch((error) => {
        if (/in progress/i.test(migrationErrorMessage(error, ''))) return false
        throw error
      })
      .then((started) =>
        check().then((job) => {
          if (isComplianceSyncJobActive(job)) return wait(intervalMs).then(poll)
          // The job is saved before the sync request returns, so an empty first check after a
          // fresh request means nothing was queued (NM CCD is not the active provider yet).
          if (started) {
            return Promise.reject({ code: 'SYNC_NOT_STARTED', message: SYNC_NOT_STARTED_MESSAGE })
          }
          return { completedAt: now() }
        }),
      )
  }

export const previewNmCcdBatchMappings = () => () =>
  previewNmCcdBatchMappingsApi().then(normalizeMappingPreview)

export const autoMapNmCcdBatches = () => () => autoMapNmCcdBatchesApi()

// Re-reads the BioTrack account first: the switchover can sit behind a long sync poll and the
// PUT carries the whole location list, so a stale store snapshot would clobber other edits.
export const disableBiotrackLocationForShop = (shopId) => () =>
  getBiotrackAccountApi().then((accounts) => {
    const biotrackAccount = (Array.isArray(accounts) ? accounts[0] : accounts) || {}
    if (!findBiotrackLocation(biotrackAccount, shopId)) return { disabled: false }
    const updatedAccount = disableBiotrackLocation(biotrackAccount, shopId)
    const location = findBiotrackLocation(updatedAccount, shopId)
    return updateBiotrackAccountApi([updatedAccount]).then(() => {
      if (!location.environment) return { disabled: true }
      // Mirror to the compliance service like the BioTrack Save flow; best effort, same as there.
      return Promise.resolve()
        .then(() =>
          updateMerchant(
            location.companyId,
            location.shopId,
            serializeBiotrackConfigRequest(location),
          ),
        )
        .catch((error) =>
          console.log(
            (error && error.message) || 'failed',
            'disableBiotrackLocationForShop mirror',
          ),
        )
        .then(() => ({ disabled: true }))
    })
  })

export const getThirdPartyProducts = (brandId, productId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(thirdPartyProductsAPI(brandId, productId), dispatch)
        .then((thirdPartyProducts) => {
          resolve(thirdPartyProducts)
          dispatch(setThirdPartyProducts({ thirdPartyProducts: thirdPartyProducts.values }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getThirdPartyBrands = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(thirdPartyBrandsAPI({ ...data }), dispatch)
        .then((thirdPartyBrands) => {
          resolve(thirdPartyBrands)
          dispatch(setThirdPartyBrands({ thirdPartyBrands: thirdPartyBrands.values }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const categoryMappingVersion2 = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(categoryMappingVersion2API(data), dispatch)
        .then((res) => {
          resolve(res)
          //dispatch(setThirdPartyBrands({thirdPartyBrands: thirdPartyBrands.values, productId}));
        })
        .catch((err) => console.log(err))
    })
  }
}

// Leafly Account Actions

export const createLeaflyAccount = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(createLeaflyAccountAPI(data), dispatch)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const updateLeaflyAccount = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateLeaflyAccountAPI(data), dispatch)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getLeaflyAccount = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getLeaflyAccountAPI(), dispatch, '', '', true, false)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          console.log(err)
          dispatch(setLeaflyAccount({}))
        })
    })
  }
}

export const getLeaflyAccountByShop = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getLeaflyAccountByShopAPI(data), dispatch)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getLeaflyAccounts = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getLeaflyAccountsAPI(data), dispatch)
        .then((res) => {
          resolve(res.values)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const deleteLeaflyAccount = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(deleteLeaflyAccountAPI(data), dispatch)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const syncLeaflyAccount = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(syncLeaflyAccountAPI(), dispatch)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getMenuApiProducts = (term, brandId, brandName, start, limit) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getMenuApiProductsAPI(term, brandId, brandName, start, limit), dispatch)
        .then((menuApiProducts) => {
          if (menuApiProducts) menuApiProducts.values = _.compact(menuApiProducts.values)
          resolve(menuApiProducts)
          dispatch(setThirdPartyProducts({ thirdPartyProducts: menuApiProducts.values }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getMenuApiBrands = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getMenuApiBrandsAPI({ ...data }), dispatch)
        .then((menuApiBrands) => {
          if (menuApiBrands) menuApiBrands.values = _.compact(menuApiBrands.values)
          resolve(menuApiBrands)
          dispatch(setThirdPartyBrands({ thirdPartyBrands: menuApiBrands.values }))
        })
        .catch((err) => console.log(err))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/thirdParty.js